<template>
  <el-dialog
    title="删除认证"
    class="f-dialog auth-delete-dialog"
    width="520px"
    :visible="visible"
    :close-on-click-modal="false"
    :close-on-press-escape="!submitting"
    :show-close="!submitting"
    @update:visible="$emit('update:visible', $event)"
  >
    <div class="delete-warning">
      <i class="el-icon-warning"></i>
      <span>
        删除认证后，当前用户不再显示认证用户特权，认证期间产生的数据会继续保留！
      </span>
    </div>
    <el-form ref="form" :model="formData" :rules="rules" label-width="100px">
      <el-form-item label-width="0">
        <el-checkbox v-model="formData.plannedDelete" :disabled="submitting">
          计划删除
        </el-checkbox>
      </el-form-item>
      <el-form-item
        v-if="formData.plannedDelete"
        label="删除日期"
        prop="deleteDate"
      >
        <el-date-picker
          v-model="formData.deleteDate"
          type="date"
          format="yyyy-MM-dd"
          value-format="yyyy-MM-dd"
          placeholder="请选择删除日期"
          :editable="false"
          :disabled="submitting"
          :picker-options="pickerOptions"
        ></el-date-picker>
        <p class="delete-tip">按北京时间，在所选日期当天自动删除。</p>
      </el-form-item>
      <el-form-item label-width="0">
        <el-checkbox
          v-model="formData.lockRegisteredUser"
          :disabled="submitting || !canLockRegisteredUser"
        >
          同步锁定注册用户
        </el-checkbox>
        <p class="delete-tip" v-if="!canLockRegisteredUser">
          当前认证未关联可锁定的分销平台注册用户。
        </p>
        <p class="delete-tip" v-else>
          {{
            formData.plannedDelete ? "执行计划删除时" : "立即删除认证时"
          }}，同时锁定关联的注册用户。
        </p>
      </el-form-item>
    </el-form>
    <div slot="footer">
      <el-button :disabled="submitting" @click="$emit('update:visible', false)">
        取消
      </el-button>
      <el-button type="primary" :loading="submitting" @click="submit">
        {{ formData.plannedDelete ? "保存删除计划" : "确定删除" }}
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import moment from "moment";
import { deleteCustomerAuth } from "@/api/visitorManage";

export default {
  props: {
    visible: Boolean,
    options: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      submitting: false,
      formData: {
        plannedDelete: !!this.options.scheduledDeleteDate,
        deleteDate: this.options.scheduledDeleteDate || "",
        lockRegisteredUser:
          !!this.options.deleteLockUser &&
          this.$route.path.includes("distribution") &&
          !!(this.options.bindingInfo && this.options.bindingInfo.bindingId)
      },
      pickerOptions: {
        disabledDate(date) {
          return (
            moment(date).format("YYYY-MM-DD") <
            moment()
              .utcOffset(8)
              .format("YYYY-MM-DD")
          );
        }
      },
      rules: {
        deleteDate: [
          {
            validator: (rule, value, callback) => {
              if (!this.formData.plannedDelete) return callback();
              if (!value) return callback(new Error("请选择计划删除日期"));
              const today = moment()
                .utcOffset(8)
                .format("YYYY-MM-DD");
              if (value < today) {
                return callback(new Error("计划删除日期不能早于今天"));
              }
              callback();
            },
            trigger: "change"
          }
        ]
      }
    };
  },
  computed: {
    canLockRegisteredUser() {
      return (
        this.$route.path.includes("distribution") &&
        !!(this.options.bindingInfo && this.options.bindingInfo.bindingId)
      );
    }
  },
  methods: {
    async submit() {
      if (this.submitting) return;
      const valid = await this.$refs.form.validate().catch(() => false);
      if (!valid) return;
      this.submitting = true;
      try {
        const res = await deleteCustomerAuth({
          id: this.options.id,
          plannedDelete: this.formData.plannedDelete,
          deleteDate: this.formData.plannedDelete
            ? this.formData.deleteDate
            : null,
          lockRegisteredUser:
            this.canLockRegisteredUser && this.formData.lockRegisteredUser
        });
        if (res) {
          this.$showSuccess(
            this.formData.plannedDelete ? "已设置计划删除" : "删除成功"
          );
          this.$emit("update:visible", false);
          this.$emit("refresh");
        }
      } finally {
        this.submitting = false;
      }
    }
  }
};
</script>

<style scoped lang="scss">
.delete-warning {
  display: flex;
  align-items: center;
  margin-bottom: 24px;
  line-height: 24px;
  .el-icon-warning {
    flex-shrink: 0;
    margin-right: 12px;
    color: #e6a23c;
    font-size: 24px;
  }
}
.delete-tip {
  margin: 6px 0 0;
  color: #909399;
  font-size: 12px;
  line-height: 20px;
}
</style>
